import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getCollectionPointForDropDown,
    AdvanceRequestFileUpload,
    getAlGroupsForDropdown,
    GetAllOperationEntityByGroupID,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getAllTaskNames
};

async function getCollectionPointForDropDown(estateID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID='+estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function AdvanceRequestFileUpload(model){
    const response = await CommonPost('/api/AdvanceRequestFileUpload/AdvanceRequestFileUpload', null, model);
    return response;
}

async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}

async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function getAllTaskNames(groupID, estateID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]
        }
    }
    return array;
}
